/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetExportRunsParams,
  GetExportRunsResponse
} from '../model';

import getExportRunsMutator from '../../../mutators/datastore-instance';



  /**
 * 組織内の書込実行履歴を時系列降順（created_at DESC, id DESC）で取得します。
 * export_rule_id を指定すると特定ルールの履歴のみ返します。
 * @summary 書込実行履歴一覧取得
 */
export const getExportRuns = (
    params?: GetExportRunsParams,
 ) => {
      return getExportRunsMutator<GetExportRunsResponse>(
      {url: `/external-storages/export-runs`, method: 'GET',
        params
    },
      );
    }
  export type GetExportRunsResult = NonNullable<Awaited<ReturnType<typeof getExportRuns>>>
